/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';

	const getJSONtag = () => {
		return $.getJSON('/ajax/topics/tag.json');
	};

	const slider = () => {
		$('.topics-main-slider').slick({
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			loop: true,
			arrows: false,
			dots: true,
			speed: 300,
			appendDots: $('.topics-main-content-in-dotted'),
			responsive: [{
				breakpoint: 768
			}],
		});

		// 初期表示
		slideTextAdd();
		// スライダー切り替わり時
		$('.topics-main-slider').on('afterChange', function(slick, currentSlide){
			slideTextAdd();
		});

		let addHtml, thisLabel, thisTitle, thisLink;
		function slideTextAdd() {
			$('.topics-main-content-add').remove();
			thisLabel = $('.topics-main-slider .slick-active .topics-main-slider-item-label').text();
			thisTitle = $('.topics-main-slider .slick-active .topics-main-slider-item-title').text();
			thisLink = $('.topics-main-slider .slick-active .topics-main-slider-item-a').attr('href');
			addHtml = '<div class="topics-main-content-add">'+
					'<a href="'+thisLink+'" class="topics-main-content-in-a">'+
					'<p class="topics-main-content-in-label">'+thisLabel+'</p>'+
					'<h2 class="topics-main-content-in-title mt10">'+thisTitle+'</h2></a></div>';
			$('.topics-main-content-in').prepend(addHtml);
		}
	};
	const tagJson = () => {
		if($('.js-tagJsonList').length) {
			getJSONtag().done((item) => {
				let itemList = item.rt_bn_tag_list;
				let htmlBlock;
				for(let i = 0; i < itemList.length; i++) {
					htmlBlock = '<li class="pure-u-1-5 pure-u-md-1-2">'+
					'<div class="mod-button03">'+
					'<a href="/topics/tag/'+itemList[i].cf_nt_url+'/">'+
					'<span class="mod-button03-text"><span class="mod-button03-text-red">#</span><span>'+itemList[i].cf_nt_name_d+'</span></span>'+
					'<span class="mod-button03-bg"></span></a></div></li>';
					$('.js-tagJsonList').append(htmlBlock);
				}
			});
		}
	};

	slider();
	tagJson();
})(window.jQuery, window.FUNCTIONS);